import React, { FC, useState, useContext, useEffect } from 'react'
import { Switch, Route } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import { ExternalLinkIcon } from '@heroicons/react/outline'
import ROUTES from '../../utils/routes'
import { TabBar, Tab } from '../../System'
import { userStore } from '../../utils/UserContext'
import { WidthController } from '../../Grid'
import { PayPalConnectModal } from '../../Modals'
import {
  Dashboard, Links, Works, Subscription, Course
} from '../Pages'
import { StyledAffiliateDashboard } from '.'
import Challenge from '../Pages/Works/Challenge'

const AffiliateDashboard: FC = () => {
  const { user } = useContext(userStore)
  const [hasAccess, setHasAccess] = useState(true)

  useEffect(() => {
    setHasAccess(!!user?.payPalToken)
  }, [user])

  return (
    <>
      <Helmet title="Affiliate Dashboard" />
      <WidthController noPadding maxWidth={980}>
        <StyledAffiliateDashboard>
          <h1>Affiliate Dashboard</h1>

          <TabBar>
            <Tab label="Earnings and Stats" to={ROUTES.affiliates.dashboard} isExact />
            <Tab label="Your Links" to={ROUTES.affiliates.links} isExact />
            <Tab label="How It Works" to={ROUTES.affiliates.works} />
            <Tab
              label={(
                <>
                  Resources <ExternalLinkIcon />
                </>
              )}
              onClick={() => window.open(ROUTES.issues.viewBySlug('affiliates'))}
              isExact
            />
          </TabBar>

          <div className="page">
            <Switch>
              <Route path={ROUTES.affiliates.dashboard} component={Dashboard} exact />
              <Route path={ROUTES.affiliates.links} component={Links} exact />
              <Route path={ROUTES.affiliates.works} component={Works} exact />
              <Route path={ROUTES.affiliates.worksSubscription} component={Subscription} exact />
              <Route path={ROUTES.affiliates.worksChallenge} component={Challenge} exact />
              <Route path={ROUTES.affiliates.worksCourse} component={Course} exact />
            </Switch>
          </div>

          <p className="disclaimer">
            By participating in the affiliate program, you are agreeing to our{' '}
            <a href={ROUTES.external.affiliateTermsOfServiceUrl} target="_blank" rel="noreferrer">
              terms
            </a>
            .
          </p>
        </StyledAffiliateDashboard>
      </WidthController>
      <PayPalConnectModal isOpen={!hasAccess} />
    </>
  )
}

export default AffiliateDashboard
